import {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';
import { useModal } from '../Modal/useModal';
import { DataUnit, DataUnitStatsItem } from '@/core/types';
import { normalizeDateFE } from '@/core/normalization';
interface ConfirmDataUnitModalContextType {
  isModalOpened: boolean;
  closeModal: () => void;
  openModal: () => void;
  activeDU?: DataUnit;
  activeDUStats?: DataUnitStatsItem;
  setActiveDU: Dispatch<SetStateAction<DataUnit | undefined>>;
  setActiveDuStats: Dispatch<SetStateAction<DataUnitStatsItem | undefined>>;
  activeDUDate?: Date;
}

export const ConfirmDataUnitModalContext =
  createContext<ConfirmDataUnitModalContextType>(
    {} as ConfirmDataUnitModalContextType
  );

export function ConfirmDataUnitModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [activeDU, setActiveDU] = useState<DataUnit>();
  const [activeDUStats, setActiveDuStats] = useState<DataUnitStatsItem>();

  const { isModalOpened, closeModal, openModal } = useModal();

  const activeDUDate = activeDU ? normalizeDateFE(activeDU.date) : undefined;

  return (
    <ConfirmDataUnitModalContext.Provider
      value={{
        isModalOpened,
        closeModal,
        openModal,
        activeDU,
        activeDUStats,
        setActiveDU,
        setActiveDuStats,
        activeDUDate,
      }}
    >
      {children}
    </ConfirmDataUnitModalContext.Provider>
  );
}
